import { render, staticRenderFns } from "./AddProductsView.vue?vue&type=template&id=0acf2b18&scoped=true"
import script from "./AddProductsView.vue?vue&type=script&lang=js"
export * from "./AddProductsView.vue?vue&type=script&lang=js"
import style0 from "./AddProductsView.vue?vue&type=style&index=0&id=0acf2b18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acf2b18",
  null
  
)

export default component.exports